import {
  Component, Input, EventEmitter, Output, ViewChild, ElementRef, OnInit, AfterViewInit,
  TemplateRef, ViewContainerRef, EmbeddedViewRef, isDevMode, ChangeDetectorRef
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
declare module 'googlemaps';
import { } from 'markerclustererplus';
import 'js-marker-clusterer';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { IPropertyCard } from '../../shared/models/propertycard';
import { PropertyListingBase } from '../property-listing-base';
import { IFilterable } from '../filterable';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';
//import { injectViewContainerRef, inject, injectTemplateRef, injectElementRef } from '@angular/core/src/render3';
import { SharedService } from '../../shared/providers/shared.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../shared/providers/validation.service';
declare var MarkerClusterer: any;
@Component({
  selector: 'map-view',
  templateUrl: './map-view.component.html'
})
export class PropertyMapViewComponent extends PropertyListingBase implements OnInit, AfterViewInit, IFilterable {
  //@ViewChild('map') mapContainer: ElementRef;
  @ViewChild('map', { static: true }) mapContainer: ElementRef;
  @ViewChild('#map', { read: ViewContainerRef }) mapContainerRef: ViewContainerRef;
  @ViewChild('mapcard', { read: TemplateRef }) mapCardTemplate: TemplateRef<any>;
  @Output() boundsChanged = new EventEmitter<google.maps.LatLngBounds>();
  private markers: google.maps.Marker[] = [];
  private mapEx: google.maps.Map;
  private markerCluster: MarkerClusterer;
  private selectedMarker: google.maps.Marker;
  private currentInfoWindow: EmbeddedViewRef<any>;
  private infoWindow: google.maps.InfoWindow;
  private activeWindow: google.maps.InfoWindow;
  private _selectedProperty: IPropertyCard;
  private isMapLoaded = false;
  private count = 0;
  timer;
  private startValue = 0;
  private totalNumbers = 0;
  public get selectedProperty(): IPropertyCard {
    return this._selectedProperty;
  }
  public set selectedProperty(v: IPropertyCard) {
    this._selectedProperty = v;
  }
  private _propertiesEx: google.maps.LatLngLiteral[] = [];
  public get propertiesEx(): google.maps.LatLngLiteral[] {
    return this._propertiesEx;
  }
  public set propertiesEx(v: google.maps.LatLngLiteral[]) {
    this._propertiesEx = v;
  }
  private _propertiesCache: IPropertyCard[] = [];
  public get propertiesCache(): IPropertyCard[] {
    return this._propertiesCache;
  }
  public set propertiesCache(v: IPropertyCard[]) {
    this._propertiesCache = v;
  }
  private _propertiesTileCache: IPropertyCard[] = [];
  public get propertiesTileCache(): IPropertyCard[] {
    return this._propertiesTileCache;
  }
  public set propertiesTileCache(v: IPropertyCard[]) {
    this._propertiesTileCache = v;
  }
  private _propertiesTileCacheBackEnd: IPropertyCard[] = [];
  public get propertiesTileCacheBackEnd(): IPropertyCard[] {
    return this._propertiesTileCacheBackEnd;
  }
  public set propertiesTileCacheBackEnd(v: IPropertyCard[]) {
    this._propertiesTileCacheBackEnd = v;
  }
  @Input() height = 200;
  @Input() width = 300;
  latFromValue: number = 25.00;
  latToValue: number = 45.00;
  longFromValue: number = -110.00;
  longToValue: number = -80.00;
  propertyForType: number;
  @Input() imagesLocation = 'assets/img/m';
  mapFlag: boolean;
  @Output() propertyListCount: EventEmitter<any> = new EventEmitter<any>();
  public getPropertyCount(propertyListCount: any): void {
    this.propertyListCount.emit(propertyListCount);
    //this.propertyCount = propertyListCount;
  }
  // tslint:disable-next-line:member-ordering
  @Input() searchCriteria: IPropertySearchCriteria;
  constructor(protected http: HttpClient, protected _propertyListingService: PropertyListingService,
    protected authService: AuthenticationService, protected loaderService: LoaderService, protected validationService: ValidationService, protected cdRef: ChangeDetectorRef, private Shared: SharedService, protected activatedRoute: ActivatedRoute) {
    super(_propertyListingService, http, authService, loaderService, activatedRoute);
  }
  filter(searchParameters: IPropertySearchCriteria, firstLoad = false) {
    this.loaderService.display(true);
    if (this.isReset) {
      this.count = 0;
    }
    if (this.propertyForType != searchParameters.PropertyFor) {
      this.isReset = true;
    }
    //this.isReset = true;
    this.searchCriteria = this._propertyListingService.criteria;
    searchParameters.IsMapView = false;
    var latFrom;
    var latTo;
    var longTo;
    var longFrom;
    if (this.searchCriteria.IsDisliked == true) {
      latFrom = localStorage.getItem("LatFromDislike");
      latTo = localStorage.getItem("LatToDislike");
      longTo = localStorage.getItem("LongToDislike");
      longFrom = localStorage.getItem("LongFromDislike");
    }
    if (this.searchCriteria.IsFavorite == true) {
      latFrom = localStorage.getItem("LatFromFavorite");
      latTo = localStorage.getItem("LatToFavorite");
      longTo = localStorage.getItem("LongToFavorite");
      longFrom = localStorage.getItem("LongFromFavorite");
    }
    else if (this.searchCriteria.IsFavorite == false && this.searchCriteria.IsDisliked == false) {
      latFrom = localStorage.getItem("LatFrom");
      latTo = localStorage.getItem("LatTo");
      longTo = localStorage.getItem("LongTo");
      longFrom = localStorage.getItem("LongFrom");
    }
    if (latFrom != null && latTo != null && longFrom != null && longTo != null) {
      searchParameters.LatFrom = latFrom;
      searchParameters.LatTo = latTo;
      searchParameters.LongFrom = longFrom;
      searchParameters.LongTo = longTo;
    }
    else {
      searchParameters.LatFrom = "25.00";
      searchParameters.LatTo = "45.00";
      searchParameters.LongFrom = "-110.00";
      searchParameters.LongTo = "-80.00";
    }
    this.searchCriteria = searchParameters;
    if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) && typeof this.searchCriteria.StateId === 'number') {
      this.searchCriteria.StateId = this.searchCriteria.StateId;
    }
    //} else if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) && typeof this.searchCriteria.StateId === 'object') {
    //  this.searchCriteria.StateId = this.searchCriteria.StateId?.[0];
    //}
    var timeNow = new Date();
    console.log("map-filter start " + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
    //this.searchCriteria.StateId = this.searchCriteria.StateId ? this.searchCriteria.StateId[0] : null;
    this.searchCriteria.IsTileList = false;
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    if (this.isUserLoggedIn) {
      let user: any = this.authService.user;
      this.searchCriteria.LoggedInUserId = user.Id;
    }
    if (!this.isReset) {
      this._propertyListingService.getPropertyListing(this.searchCriteria).subscribe((response: IPropertyCard[]) => {

        if (firstLoad || (response.length>0&&response[0].TotalCount < 25)) {
          timeNow = new Date();

          this.propertiesCache = response;
          this.propertiesTileCacheBackEnd = response;
          console.log('Filte after response > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
          if (response.length > 100) {
            this.propertiesTileCache = response.slice(0, 100);
          }
          else {
            this.propertiesTileCache = response;
          }
          this.propertyCount = (this.propertiesTileCache != null && this.propertiesTileCache.length > 0) ? this.propertiesTileCache[0].TotalCount : 0;
          console.log('1' +this.propertyCount);
          this.getPropertyCount(this.propertyCount);
          //this.cdRef.detectChanges();
          if (this.activeWindow) { this.activeWindow.close(); }
          this.refreshMap();
          //this.loaderService.display(false);
          timeNow = new Date();
          console.log('Filter end > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
        }
        else {
          var that = this;
          this.totalNumbers = 5000;
          this.startValue = 0;
          this.timer = setInterval(function () {
            that.refreshMapData(true, that.startValue == 0);
          }, 500);
        }
      });
    }
    else {
      var that = this;
      this.totalNumbers = 5000;
      this.startValue = 0;
      this.timer = setInterval(function () {

        that.refreshMapData(true, that.startValue == 0);
      }, 500);
    }

  }
  refreshMapData(isFirstLoad = false, isFirstTime = false) {
    //this.searchCriteria = this._propertyListingService.criteria;
    if ((this.startValue < this.totalNumbers && isFirstLoad) || !isFirstLoad) {
      var timeNow = new Date();
      console.log('Refresh Begin > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
      const that = this;
      if (!that.markerCluster) {
        that.markerCluster = new MarkerClusterer(that.mapEx, that.markers,
          { imagePath: that.imagesLocation });
      }

      if (that.selectedMarker != null) {
        that.selectedMarker.setMap(null);
      }
      var endvalue = (this.startValue + 500) > this.totalNumbers ? this.totalNumbers : this.startValue + 500;
      this.searchCriteria.TakeCount = 500;
      this.searchCriteria.SkipCount = this.startValue;
      this.startValue = endvalue;
      this._propertyListingService.getPropertyListing(this.searchCriteria).subscribe((response: IPropertyCard[]) => {
        let missing = response.filter(item => this.propertiesCache.indexOf(item) < 0);
        this.propertiesCache = !isFirstTime ? (this.propertiesCache != null ? this.propertiesCache.concat(missing) : response) : response;
        if (isFirstTime) {
          that.markerCluster.clearMarkers();
        }
        
        if (this.activeWindow) { this.activeWindow.close(); }
        //this.refreshMap();
        if (this.searchCriteria.SkipCount < 500) {
          this.propertyCount = (this.propertiesCache != null && this.propertiesCache.length > 0) ? this.propertiesCache[0].TotalCount : 0;
          this.totalNumbers = this.propertyCount;
          console.log('2' +this.propertyCount);
          this.getPropertyCount(this.propertyCount);
        }
        this.propertiesTileCacheBackEnd = !isFirstTime ? this.propertiesTileCacheBackEnd.concat(response) : response;
        if (this.propertiesTileCacheBackEnd.length > 0) {
          if (response.length > 100) {
            this.propertiesTileCache = this.propertiesTileCacheBackEnd.slice(0, 100);
          }
          else {
            this.propertiesTileCache = this.propertiesTileCacheBackEnd;
          }
        }
        this.searchCriteria.IsTileList = true;
        const markers = response.map(function (location, i) {
          const marker = new google.maps.Marker({
            position: { lat: location.Lat, lng: location.Lng },
            icon: 'assets/img/map-icon.sm.png',
            title: location.PropertyName
          });
          marker.addListener('click', (e: google.maps.MapMouseEvent) => {
            if (that.activeWindow) { that.activeWindow.close(); }
            that.selectedProperty = that.propertiesTileCacheBackEnd.find(x => {
              return x.Lat === parseFloat(e.latLng.lat().toString())
                && x.Lng.toFixed(7) === e.latLng.lng().toFixed(7);
            });
            if (!that.propertiesTileCache.some((item) => item.Id == that.selectedProperty.Id)) {
              that.propertiesTileCache.push(that.selectedProperty);
            }
            that.selectedMarker = that.markers.find(x => x.getPosition().lat() === e.latLng.lat() &&
              x.getPosition().lng() === e.latLng.lng());
            if (that.selectedMarker) {
              if (!that.selectedMarker.getMap()) {
                that.selectedMarker.setMap(that.mapEx);
              }
            }
            if (that.selectedProperty) {
              if (that.selectedProperty.FilePath === undefined || that.selectedProperty.FilePath === null) {
                that.selectedProperty.FilePath = '/../../../assets/img/default-property_1.png'
              }
              var content = ' <div class="property-map ">' +
                ' <div class="imgblock" style= "background-image:url(' + that.selectedProperty.FilePath + ')" > </div>' +
                '<h2> <strong>' + that.selectedProperty.PropertyName + '</strong><span>' + that.selectedProperty.City + ', ' + that.selectedProperty.State + '</span > </h2>' +
                '<h3>' + '$ ' + that.validationService.decimalCommaFormat(that.selectedProperty.Price) + ' </h3>' +
                '</div>'
              that.infoWindow = new google.maps.InfoWindow({
                content: content,
                maxWidth: 200,
              });
              console.log("that.selectedProperty.Id-" + that.selectedProperty.Id);
              that.Shared.highlightPropertyCard(that.selectedProperty.Id);
              that.infoWindow.open(that.mapEx, that.selectedMarker);
              that.activeWindow = that.infoWindow;
              that.infoWindow.addListener('closeclick', (e: google.maps.MapMouseEvent) => {
                that.Shared.highlightPropertyCard(null);
              });
            }
          });
          if (that.isReset == true ) {
            if (that.mapEx != null) {
              const southWest = new google.maps.LatLng(that.latFromValue, that.longFromValue);
              const northEast = new google.maps.LatLng(that.latToValue, that.longToValue);
              const bounds = new google.maps.LatLngBounds(southWest, northEast);
              that.mapEx.fitBounds(bounds);
              that.count += 1
            }
          }
          that.isReset = false;
          that.markers.push(marker);
          return marker;
        });
        that.markerCluster.addMarkers(markers);
        that.markerCluster.draw();
        this.loaderService.display(false);
        //this.cdRef.detectChanges();
        timeNow = new Date();
        console.log('Refresh End > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
      });
    }
    else {
      this.loaderService.display(false);
      clearInterval(this.timer);
    }
  }
  refreshMap() {

    var timeNow = new Date();
    console.log('Refresh Begin > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
    const that = this;
    if (!that.markerCluster) {
      that.markerCluster = new MarkerClusterer(that.mapEx, that.markers,
        { imagePath: that.imagesLocation });
    }
    that.markerCluster.clearMarkers();
    if (that.selectedMarker != null) {
      that.selectedMarker.setMap(null);
    }
    const markers = that.propertiesCache.map(function (location, i) {
      const marker = new google.maps.Marker({
        position: { lat: location.Lat, lng: location.Lng },
        icon: 'assets/img/map-icon.sm.png',
        title: location.PropertyName
      });
      marker.addListener('click', (e: google.maps.MapMouseEvent) => {
        if (that.activeWindow) { that.activeWindow.close(); }
        that.selectedProperty = that.propertiesTileCacheBackEnd.find(x => {
          return x.Lat === parseFloat(e.latLng.lat().toString())
            && x.Lng.toFixed(7) === e.latLng.lng().toFixed(7);
        });
        if (!that.propertiesTileCache.some((item) => item.Id == that.selectedProperty.Id)) {
          that.propertiesTileCache.push(that.selectedProperty);
        }
        that.selectedMarker = that.markers.find(x => x.getPosition().lat() === e.latLng.lat() &&
          x.getPosition().lng() === e.latLng.lng());
        if (that.selectedMarker) {
          if (!that.selectedMarker.getMap()) {
            that.selectedMarker.setMap(that.mapEx);
          }
        }
        if (that.selectedProperty) {
          if (that.selectedProperty.FilePath === undefined || that.selectedProperty.FilePath === null) {
            that.selectedProperty.FilePath = '/../../../assets/img/default-property_1.png'
          }
          var content = ' <div class="property-map ">' +
            ' <div class="imgblock" style= "background-image:url(' + that.selectedProperty.FilePath + ')" > </div>' +
            '<h2> <strong>' + that.selectedProperty.PropertyName + '</strong><span>' + that.selectedProperty.City + ', ' + that.selectedProperty.State + '</span > </h2>' +
            '<h3>' + '$ ' + that.validationService.decimalCommaFormat(that.selectedProperty.Price) + ' </h3>' +
            '</div>'
          that.infoWindow = new google.maps.InfoWindow({
            content: content,
            maxWidth: 200,
          });
          console.log("that.selectedProperty.Id-" + that.selectedProperty.Id);
          that.Shared.highlightPropertyCard(that.selectedProperty.Id);
          that.infoWindow.open(that.mapEx, that.selectedMarker);
          that.activeWindow = that.infoWindow;
          that.infoWindow.addListener('closeclick', (e: google.maps.MapMouseEvent) => {
            that.Shared.highlightPropertyCard(null);
          });
        }
      });
      if (that.isReset == true) {
        if (that.mapEx != null) {
          const southWest = new google.maps.LatLng(that.latFromValue, that.longFromValue);
          const northEast = new google.maps.LatLng(that.latToValue, that.longToValue);
          const bounds = new google.maps.LatLngBounds(southWest, northEast);
          that.mapEx.fitBounds(bounds);
          that.count += 1
        }
      }
      that.isReset = false;
      that.markers.push(marker);
      return marker;
    });
    that.markerCluster.addMarkers(markers);
    that.markerCluster.draw();
    timeNow = new Date();
    console.log('Refresh End > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
  }
  ngOnInit() {
    this.loaderService.display(true);
    this.Shared.highlightPropertyCard(null);
    this.loaderService.display(true);
    this.mapFlag = true;
    this.propertyCount = 0;
    this.totalNumbers = 5000;
    this.searchCriteria.LatFrom = '25.00';
    this.searchCriteria.LatTo = '45.00';
    this.searchCriteria.LongFrom = '-120.00';
    this.searchCriteria.LongTo = '-80.00';
    this.propertyForType = this.searchCriteria.PropertyFor;
    this.filter(this.searchCriteria, true);
    this.mapEx = new google.maps.Map(this.mapContainer.nativeElement,
      {
        zoom: 3,
        center: { lat: -28.024, lng: 140.887 },
      });
    const southWest = new google.maps.LatLng(this.latFromValue, this.longFromValue);
    const northEast = new google.maps.LatLng(this.latToValue, this.longToValue);
    const bounds = new google.maps.LatLngBounds(southWest, northEast);
    this.mapEx.fitBounds(bounds);
    const that = this;
    this.mapEx.addListener('dragend', () => {
      this.boundsChanged.emit(this.mapEx.getBounds());
      const bounds = this.mapEx.getBounds();
      var latFrom = bounds.getSouthWest().toJSON().lat.toString();
      var latTo = bounds.getNorthEast().toJSON().lat.toString();
      var longFrom = bounds.getSouthWest().toJSON().lng.toString();
      var longTo = bounds.getNorthEast().toJSON().lng.toString();
      if (this.searchCriteria.IsDisliked) {
        localStorage.setItem("LatFromDislike", latFrom);
        localStorage.setItem("LatToDislike", latTo);
        localStorage.setItem("LongToDislike", longTo);
        localStorage.setItem("LongFromDislike", longFrom);
      }
      if (this.searchCriteria.IsFavorite) {
        localStorage.setItem("LatFromFavorite", latFrom);
        localStorage.setItem("LatToFavorite", latTo);
        localStorage.setItem("LongToFavorite", longTo);
        localStorage.setItem("LongFromFavorite", longFrom);
      }
      else {
        localStorage.setItem("LatFrom", latFrom);
        localStorage.setItem("LatTo", latTo);
        localStorage.setItem("LongTo", longTo);
        localStorage.setItem("LongFrom", longFrom);
      }
      this.filterFromClusters();
    });
    this.mapEx.addListener('zoom_changed', () => {
      if (!this.mapFlag && this.count <= 2) {
        this.boundsChanged.emit(this.mapEx.getBounds());
        const bounds = this.mapEx.getBounds();
        var latFrom = bounds.getSouthWest().toJSON().lat.toString();
        var latTo = bounds.getNorthEast().toJSON().lat.toString();
        var longFrom = bounds.getSouthWest().toJSON().lng.toString();
        var longTo = bounds.getNorthEast().toJSON().lng.toString();
        if (this.searchCriteria.IsDisliked) {
          localStorage.setItem("LatFromDislike", latFrom);
          localStorage.setItem("LatToDislike", latTo);
          localStorage.setItem("LongToDislike", longTo);
          localStorage.setItem("LongFromDislike", longFrom);
        }
        if (this.searchCriteria.IsFavorite) {
          localStorage.setItem("LatFromFavorite", latFrom);
          localStorage.setItem("LatToFavorite", latTo);
          localStorage.setItem("LongToFavorite", longTo);
          localStorage.setItem("LongFromFavorite", longFrom);
        }
        else {
          localStorage.setItem("LatFrom", latFrom);
          localStorage.setItem("LatTo", latTo);
          localStorage.setItem("LongTo", longTo);
          localStorage.setItem("LongFrom", longFrom);
        }
        this.filterFromClusters();
        this.propertyCount = (this.propertiesTileCache != null && this.propertiesTileCache.length > 0) ? this.propertiesTileCache[0].TotalCount : 0;
        console.log('3' +this.propertyCount);
        this.getPropertyCount(this.propertyCount);
        console.log("PropertyCount: " + this.propertyCount);
      }
      this.mapFlag = false;
    });
    this.mapEx.addListener('idle', () => {
    });
    this.Shared.resetValueClicked.subscribe(res => {
      if (res == true) {
        this.searchCriteria.IsSearchButtonClicked = false;
        this.isReset = true;
      }
    });
    this.Shared.filterValueClicked.subscribe(res => {
      if (res == true) {
        this.isReset = true;
      }
    });
    this.Shared.favouriteValueClicked.subscribe(res => {
      if (res == true && this.searchCriteria.IsMapView == true) {
        this.filterFromClusters();
      }
    });
    this.Shared.dislikeValueClicked.subscribe(res => {
      if (res == true && this.searchCriteria.IsMapView == true) {
        this.filterFromClusters();
      }
    });
    this.timer = setInterval(function () { that.refreshMapData(true, that.startValue == 0); }, 500);
  }
  isReset = false;
  filterFromClusters(onDone?: Function) {
    this.loaderService.display(true);
    var timeNow = new Date();
    console.log('Filter Clusters Begin > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
    //this.loaderService.display(true);
    var latFrom;
    var latTo;
    var longTo;
    var longFrom;
    if (this.searchCriteria.IsDisliked == true) {
      latFrom = localStorage.getItem("LatFromDislike");
      latTo = localStorage.getItem("LatToDislike");
      longTo = localStorage.getItem("LongToDislike");
      longFrom = localStorage.getItem("LongFromDislike");
    }
    if (this.searchCriteria.IsFavorite == true) {
      latFrom = localStorage.getItem("LatFromFavorite");
      latTo = localStorage.getItem("LatToFavorite");
      longTo = localStorage.getItem("LongToFavorite");
      longFrom = localStorage.getItem("LongFromFavorite");
    }
    else if (this.searchCriteria.IsFavorite == false && this.searchCriteria.IsDisliked == false) {
      latFrom = localStorage.getItem("LatFrom");
      latTo = localStorage.getItem("LatTo");
      longTo = localStorage.getItem("LongTo");
      longFrom = localStorage.getItem("LongFrom");
    }
    const searchCriteria = $.extend(true, {}, this.searchCriteria);
    if (!this.isReset) {
      if (latFrom != null && latTo != null && longFrom != null && longTo != null) {
        searchCriteria.LatFrom = latFrom;
        searchCriteria.LatTo = latTo;
        searchCriteria.LongFrom = longFrom;
        searchCriteria.LongTo = longTo;
      } else {
        this.boundsChanged.emit(this.mapEx.getBounds());
        const bounds = this.mapEx.getBounds();
        searchCriteria.LatFrom = bounds.getSouthWest().toJSON().lat.toString();
        searchCriteria.LatTo = bounds.getNorthEast().toJSON().lat.toString();
        searchCriteria.LongFrom = bounds.getSouthWest().toJSON().lng.toString();
        searchCriteria.LongTo = bounds.getNorthEast().toJSON().lng.toString();
      }
    }
    searchCriteria.IsMapView = true;
    searchCriteria.IsTileList = true;
    searchCriteria.SkipCount = 0;
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    if (this.isUserLoggedIn) {
      let user: any = this.authService.user;
      searchCriteria.LoggedInUserId = user.Id;
    }
    this._propertyListingService.getPropertyListing(searchCriteria).subscribe((response: IPropertyCard[]) => {

      timeNow = new Date();
      console.log('Filter Clusters after response > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
      if (response.length > 100) {
        response = response.slice(0, 100);
      }
      this.propertiesTileCache = response;
      this.propertyCount = (this.propertiesTileCache != null && this.propertiesTileCache.length > 0) ? this.propertiesTileCache[0].TotalCount : 0;
      console.log('4'+this.propertyCount);

      this.getPropertyCount(this.propertyCount);
      //this.cdRef.detectChanges();
      if (this.activeWindow) { this.activeWindow.close(); }
      this.refreshMap();
      this.loaderService.display(false);
      if (onDone) {
        setTimeout(onDone, 100);
      }
      timeNow = new Date();
      console.log('Filter Clusters end > ' + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
    });
  }
  ngAfterViewInit(): void {
  }
  private assign(obj: any, prop: any, value: any) {
    if (typeof prop === 'string') {
      prop = prop.split('.');
    }
    if (prop.length > 1) {
      const e = prop.shift();
      this.assign(obj[e] =
        Object.prototype.toString.call(obj[e]) === '[object Object]'
          ? obj[e]
          : {},
        prop,
        value);
    } else {
      obj[prop[0]] = value;
    }
  }
  private getUniqueFeatures(array: IPropertyCard[], comparatorProperty: string) {
    let existingFeatureKeys: any = new Object();
    let uniqueFeatures: any[] = array.filter(function (el) {
      if (existingFeatureKeys[el[comparatorProperty]]) {
        return false;
      } else {
        existingFeatureKeys[el[comparatorProperty]] = true;
        return true;
      }
    });
    return uniqueFeatures;
  }
}
